import auth from '../reducers/auth';

export const Auth0Config = () => {
    const JEST_HOSTS = ['testing'];
    const TEST_HOSTS = ['employers.test.bcidaho.com'];
    const STAGE_HOSTS = ['employers.stag.bcidaho.com'];
    const PROD_HOSTS = ['employers.bcidaho.com', 'employers.stag.core.aws.bcidaho.loc'];
    let auth0Config = {
        domain: 'dvlp.business.cloudauth.bcidaho.com',
        client: 'KayEBPPb457jsBdkZ38Lrqwv3ZOmthNc'
    };
    if (JEST_HOSTS.filter(host => host === window.location.hostname).length > 0)
        auth0Config = {
            domain: 'test-domain',
            client: 'test-client'
        };
    if (TEST_HOSTS.filter(host => host === window.location.hostname).length > 0)
        auth0Config = {
            domain: 'test.business.cloudauth.bcidaho.com',
            client: 'fUSCMIpFSkQdn16lk4BMpkKJAgTOMR50'
        };

    if (STAGE_HOSTS.filter(host => host === window.location.hostname).length > 0)
        auth0Config = {
            domain: 'stag.business.cloudauth.bcidaho.com',
            client: 'P5GYsFxDGjTMiKqJQw1F7u14fmFekJp1'
        };

    if (PROD_HOSTS.filter(host => host === window.location.hostname).length > 0)
        auth0Config = {
            domain: 'prod.business.cloudauth.bcidaho.com',
            client: 'AgT9oudpVVyzTcgLtilLLX5sOVg2xhCr'
        };

    // generate Auth0 logout url.
    const { origin } = window.location;
    const { domain, client } = auth0Config;
    const loginUrl = `${origin}/login`;
    const logoutUrl = `https://${domain}/v2/logout?client_id=${client}&returnTo=${loginUrl}`;
    console.log('logout', logoutUrl);
    auth0Config.logoutUrl = logoutUrl;

    return auth0Config;
};
